import { create } from 'zustand';
import type { AdminState, AdminActions } from './types';

interface AdminStore extends AdminState, AdminActions {}

export const useAdminStore = create<AdminStore>((set) => ({
  selectedUserId: null,
  isProcessingTask: false,
  activeTaskId: null,
  filters: {
    status: 'all',
    assignedTo: 'all',
  },

  setSelectedUser: (userId) => set({ selectedUserId: userId }),
  setProcessingTask: (isProcessing) => set({ isProcessingTask: isProcessing }),
  setActiveTask: (taskId) => set({ activeTaskId: taskId }),
  updateFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters }
    })),
}));